import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux'
import './index.less';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import store from './store';
import reportWebVitals from 'reportWebVitals';
import Router from './routers';
import { register } from 'serviceWorker';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';

dayjs.locale('zh-cn');
// if (process.env.NODE_ENV === 'development') {
//     import('./mocks/index')
// }
createRoot((document as any).getElementById('root')).render(
    <Provider store={store}>
        <ConfigProvider locale={zhCN}>
            <Router />
        </ConfigProvider>
    </Provider>
);
const m: any = module;
if (m.hot) {
    m.hot.accept();
}
reportWebVitals(console.log)
register()
